/* Sunday Set gallery behaviour (snippets/afroyla-sunday-set-gallery.liquid).
 * Swiping is native (CSS scroll-snap) — this file only keeps the counter, the thumb rail and the
 * arrows in step with the track, and drives them: thumb click / arrow click / arrow keys → scrollTo. */
(function () {
  'use strict';

  function init(root) {
    if (root.__aflSgal) return;
    root.__aflSgal = true;
    var track = root.querySelector('[data-afl-sgal-track]');
    if (!track) return;
    /* 23.09 colour-in-place: panes / thumbs carrying `hidden` (a colour without that photo) are skipped, and
       root.__aflSgalRefresh() re-reads them after the set box re-points the gallery to another colour. */
    function visible(list) {
      var out = [];
      for (var v = 0; v < list.length; v += 1) if (!list[v].hidden) out.push(list[v]);
      return out;
    }
    var panes = visible(track.querySelectorAll('[data-afl-sgal-pane]'));
    var n = panes.length;
    if (!n) return;
    var thumbs = visible(root.querySelectorAll('[data-afl-sgal-thumb]'));
    var allThumbs = root.querySelectorAll('[data-afl-sgal-thumb]');
    var count = root.querySelector('[data-afl-sgal-count]');
    var prev = root.querySelector('[data-afl-sgal-prev]');
    var next = root.querySelector('[data-afl-sgal-next]');
    var cur = 0;

    function paint(i) {
      cur = i;
      if (count) count.textContent = (i + 1) + ' / ' + n;
      for (var t = 0; t < thumbs.length; t += 1) {
        var on = t === i;
        thumbs[t].classList.toggle('is-active', on);
        thumbs[t].setAttribute('aria-pressed', on ? 'true' : 'false');
        /* 25.09: scroll the THUMB RAIL only, never the window. scrollIntoView({block:'nearest'}) also scrolled the
           document when the rail sat below the fold — on load, paint(0) dropped every visitor ~600 px past the H1. */
        if (on) {
          var rail = thumbs[t].parentElement;
          if (rail) {
            var l = thumbs[t].offsetLeft, r = l + thumbs[t].offsetWidth;
            if (rail.scrollWidth > rail.clientWidth) {
              if (l < rail.scrollLeft) rail.scrollLeft = l;
              else if (r > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = r - rail.clientWidth;
            }
            var tp = thumbs[t].offsetTop, bt = tp + thumbs[t].offsetHeight;
            if (rail.scrollHeight > rail.clientHeight) {
              if (tp < rail.scrollTop) rail.scrollTop = tp;
              else if (bt > rail.scrollTop + rail.clientHeight) rail.scrollTop = bt - rail.clientHeight;
            }
          }
        }
      }
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
    }

    function go(i) {
      i = Math.max(0, Math.min(n - 1, i));
      var left = i * track.clientWidth;
      if (track.scrollTo) track.scrollTo({ left: left, behavior: 'smooth' });
      else track.scrollLeft = left;
      paint(i);
    }

    var timer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== cur) paint(Math.max(0, Math.min(n - 1, i)));
      }, 80);
    }, { passive: true });

    for (var t = 0; t < allThumbs.length; t += 1) {
      (function (btn) { btn.addEventListener('click', function () { go(thumbs.indexOf(btn)); }); })(allThumbs[t]);
    }
    root.__aflSgalRefresh = function () {
      for (var h = 0; h < allThumbs.length; h += 1) { allThumbs[h].classList.remove('is-active'); allThumbs[h].setAttribute('aria-pressed', 'false'); }
      panes = visible(track.querySelectorAll('[data-afl-sgal-pane]'));
      thumbs = visible(root.querySelectorAll('[data-afl-sgal-thumb]'));
      n = panes.length;
      cur = 0;
      track.scrollLeft = 0;
      paint(0);
    };
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    });
    /* a resize (rotation) changes the pane width — re-seat on the current pane */
    window.addEventListener('resize', function () { track.scrollLeft = cur * track.clientWidth; });
    paint(0);
  }

  function adoptAll() {
    var roots = document.querySelectorAll('[data-afl-sgal]');
    for (var i = 0; i < roots.length; i += 1) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', adoptAll);
  else adoptAll();
})();
